export default __webpack_public_path__ + "media/images/calculator-4bb1a42503e574bc58ec17c3e8cf5763.png";